<template>
  <div class="editor scroll-vertical big-spacer">
    <content-nav-bar>
      <svgicon class="level-item event-icon"
        :name="iconName" width="25" height="25" :original="true">
      </svgicon>
      <i class="level-item small fas fa-arrow-right"></i>
      <p class="block level-item ellipsis title-item">
          {{ name }}
      </p>
    </content-nav-bar>
    <content-nav-bar>Host Info</content-nav-bar>
    <alert-log-host-details :item="log"></alert-log-host-details>
    <content-nav-bar>{{ log.parsed.eventType }} Details</content-nav-bar>
    <event-details
      :event="log.parsed.match.event"
      :related="log.parsed.related"
      :type="log.parsed.eventType">
    </event-details>
    <content-nav-bar>Analytic Match Details</content-nav-bar>
    <alert-log-details
      :item="log"
      v-on:tag-click="$emit('tag-click', $event)">
    </alert-log-details>
  </div>
</template>

<script>
import alertlog from '@/mixins/alertlog';
import EventDetails from '@/components/events/EventDetails.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';
import AlertLogDetails from '@/components/alertlogs/AlertLogDetails.vue';
import AlertLogHostDetails from '@/components/alertlogs/AlertLogHostDetails.vue';

export default {
  name: 'LogDetails',
  mixins: [alertlog],
  components: {
    AlertLogDetails,
    EventDetails,
    ContentNavBar,
    AlertLogHostDetails,
  },
  props: {
    log: {
      type: Object,
      required: true,
    },
  },
  computed: {
    name() {
      return this.getName(this.log);
    },
    iconName() {
      return this.getIconName(this.log);
    },
  },
  data() {
    return {
      text: null,
    };
  },
};
</script>

<style lang="scss" scoped>
.big-spacer {
  padding-bottom: 8rem;
}
</style>
